import { EyeIcon, PencilAltIcon, XIcon } from "@heroicons/react/solid";
import { Modal } from "@mui/material";
import { useEffect, useState } from "react";
import Moment from "react-moment";
import {
  Link,
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { getUserLeaveData } from "../../api";
import spinner from "../../assets/images/spinner.gif";
import ZoomImage from "../../components/ZoomImage";
import Cookies from "universal-cookie";
import { ROLE } from "../../config";
import NewLeaveDetail from "./NewLeaveDetail";
import Pagination from "../../components/pagination";
import DatePicker from "react-datepicker";
import LeaveManagement from "./LeaveManagement";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import LeavesUtilised from "../../components/sections/leaves/LeavesUtilised";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import RoundedContainer from "../../components/containers/RoundedContainer";
import { Button } from "../../components/ui";

const cookies = new Cookies();

function LeaveDetail() {
  const [pageNo, setPageNo] = useState(0);
  const breadcrumbs = [
    { label: "Employee Details", link: "/employee-details" },
    { label: "Leave Details", link: "" },
  ];

  const [year, setYear] = useState(new Date());
  const { company_employee_id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  let initialHolidayFilterData = {
    limit: 10,
    page_no: 0,
    company_employee_id: company_employee_id,
    // month_and_year: searchParams.get("month_and_year")
    //   ? new Date(searchParams.get("month_and_year"))
    //   : new Date()
    month_year: year.getFullYear(),
  };

  const [filterData, setFilterData] = useState(initialHolidayFilterData);
  let initialHolidayData = {
    limit: 10,
    company_employee_id: company_employee_id,
    // search_query: searchParams.get("search_query") || "",
    page_no: 0,
    // month_and_year: searchParams.get("month_and_year"),
    month_year: year.getFullYear(),
  };

  // const {
  //   list: holidayList,
  //   // paramsObject,
  //   setGetListParams,
  // } = useGet({
  //   url: "getUserLeaveCount",
  //   method: "get",
  //   initialData: initialHolidayData,
  // });

  const handleSetYear = (value) => {
    let data = {
      ...paramsObject,
      company_employee_id: company_employee_id,
      month_year: value.getFullYear(),
    };

    let dataForSearchParams = {
      ...paramsObject,
      company_employee_id: company_employee_id,
      month_year: value.getFullYear(),
    };
    getLeaveData(
      company_employee_id,
      paramsObject.page_no,
      paramsObject.limit,
      value.getFullYear()
    );
    setYear(value);
    // setGetListParams(data);
    setSearchParams(dataForSearchParams);
    setFilterData(dataForSearchParams);
  };

  const [role, setRole] = useState("");
  const [activeTab, setActiveTab] = useState("leaveDetails");
  useEffect(() => {
    setRole(cookies.get(ROLE));
  }, []);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [leaveInfo, setLeaveInfo] = useState("");
  const [leaveData, setLeaveData] = useState([]);
  const [userId, setUserId] = useState("");
  const [leaveDocument, setLeaveDocument] = useState([]);
  const [singleLeaveData, setSingleLeaveData] = useState({});
  const [isOpenDocumentModal, setIsOpenDocumentModal] = useState(false);
  const [paramsObject, setParamsObject] = useState({
    page_no: 0,
    limit: 10,
    month_year: year.getFullYear(),
  });
  const [userLeaveCount, setUserLeaveCount] = useState(null);

  useEffect(() => {
    handleGetUserLeaveData();
  }, []);
  useEffect(() => {
    setRole(cookies.get("ROLE"));
    handleGetUserLeaveData();
  }, [paramsObject]); // Refetch when paramsObject changes

  const getLeaveData = (company_employee_id, page_no, limit, month_year) => {
    getUserLeaveData(company_employee_id, page_no, limit, month_year)
      .then((res) => {
        if (res.status === 200) {
          setLeaveData(res.data.data);
          setLeaveInfo(res.data);
          // setUserLeaveCount
          setIsLoading(false);
        }
      })
      .catch((err) => {
        alert("something went wrong please refresh");
        setIsLoading(false);
      });
  };

  const handleGetUserLeaveData = () => {
    setIsLoading(true);
    getLeaveData(
      company_employee_id,
      paramsObject.page_no,
      paramsObject.limit,
      paramsObject.month_year
    );
  };

  const handleFetchUserDocuments = (id) => {
    setUserId(id);
    setSingleLeaveData(leaveData.find((data) => data.id === id));
    setIsOpenDocumentModal(true);
  };

  const { username } = useParams();

  const handlePageClick = (page) => {
    // Update paramsObject when page changes
    getLeaveData(
      company_employee_id,
      page.selected,
      paramsObject.limit,
      paramsObject.month_year
    );
    setPageNo(page.selected);
    // setParamsObject((prev) => ({
    //   ...prev,
    //   page_no: pageNo,
    // }));
  };

  return (
    <>
      <div className="px-4 py-5">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>
      <div className="pb-20">
        {username ? (
          <p className="text-2xl font-semibold ml-4  text-primary">
            {username}
          </p>
        ) : (
          " "
        )}
        <div className="container px-4">
          <div className="tabs">
            {/* Tab Buttons */}
            <div className="flex border-b pb-2 mb-4 justify-between items-center">
              <ul className="flex">
                <li
                  className={`px-4 py-2 focus:outline-none ${
                    activeTab === "leaveDetails" ? "active" : ""
                  }`}
                >
                  <button onClick={() => setActiveTab("leaveDetails")}>
                    Leave Application
                  </button>
                </li>
                <li
                  className={`px-4 py-2 focus:outline-none ${
                    activeTab === "leavemanagement" ? " active " : ""
                  }`}
                >
                  <button onClick={() => setActiveTab("leavemanagement")}>
                    Leave Management
                  </button>
                </li>
                <li
                  className={`px-4 py-2 focus:outline-none ${
                    activeTab === "leavesUtilised" ? "active" : ""
                  }`}
                >
                  <button onClick={() => setActiveTab("leavesUtilised")}>
                    Leaves Utilised
                  </button>
                </li>
              </ul>

              <div className="flex items-center whitespace-nowrap">
                <span className="roboto mr-2">Select Year:</span>
                <DatePicker
                  name="month_year"
                  autoComplete="false"
                  className="input w-[160px]"
                  selected={year}
                  dateFormat="yyyy"
                  showYearPicker
                  onChange={handleSetYear}
                />
              </div>
            </div>
          </div>
          {/* <div className="flex gap-20 ml-4 items-center">
            <div className="bg-primary text-white font-semibold p-5 rounded-xl my-5">
              <span className="mr-2">Applicable Leave:</span>
              {holidayList?.data?.data?.applicable}
            </div>
            <div className="bg-primary text-white font-semibold p-5 rounded-xl my-5">
              <span className="mr-2"> Remaining Leave:</span>
              {holidayList?.data?.data?.remaining}
            </div>
          </div> */}
        </div>
        {isLoading ? (
          <div className="w-12 h-12 mx-auto mt-10">
            <img src={spinner} alt="spinner" className="w-full h-full" />
          </div>
        ) : (
          <div className="container px-4">
            <div className="grid grid-cols-4 gap-x-4 mt-4">
              {leaveInfo.pending_pl_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_pl_leave}/${leaveInfo.applicable_pl}`}</h1>
                  <h3 className="text-lg font-semibold">PL Available</h3>
                </div>
              )}

              {leaveInfo.pending_cl_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_cl_leave}/${leaveInfo.applicable_cl}`}</h1>
                  <h3 className="text-lg font-semibold">CL Available</h3>
                </div>
              )}

              {leaveInfo.pending_sl_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_sl_leave}/${leaveInfo.applicable_sl}`}</h1>
                  <h3 className="text-lg font-semibold">SL Available</h3>
                </div>
              )}

              {leaveInfo.pending_ol_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_ol_leave}/${leaveInfo.applicable_ol}`}</h1>
                  <h3 className="text-lg font-semibold">OL Available</h3>
                </div>
              )}

              {leaveInfo.pending_dl_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_dl_leave}/${leaveInfo.applicable_dl}`}</h1>
                  <h3 className="text-lg font-semibold">DL Available</h3>
                </div>
              )}
            </div>
            {activeTab === "leaveDetails" &&
              (leaveData.length <= 0 ? (
                <div className="text-center">
                  <p className=" text-gray-700 text-3xl">No Leaves To Show</p>
                </div>
              ) : (
                <div className="max-w-full overflow-x-auto">
                  <RoundedContainer>
                    <Table className="table-auto w-full">
                      <TableHead>
                        <TableHeaderCell className="w-[8%] text-center">
                          Sr.no
                        </TableHeaderCell>
                        <TableHeaderCell className="w-[20%] text-center">
                          Dates
                        </TableHeaderCell>
                        <TableHeaderCell className="w-[22%]">
                          Reason
                        </TableHeaderCell>
                        <TableHeaderCell className="w-[14%] text-center">
                          Leave Type
                        </TableHeaderCell>
                        <TableHeaderCell className="w-[12%] text-center">
                          Status
                        </TableHeaderCell>
                        <TableHeaderCell className="w-[12%] text-center">
                          Document
                        </TableHeaderCell>
                        <TableHeaderCell className="w-[12%] text-center">
                          Action
                        </TableHeaderCell>
                      </TableHead>
                      <TableBody>
                        {leaveData?.map((data, idx) => {
                          return (
                            <TableRow key={idx}>
                              <TableCell className="text-center text-dark font-medium text-sm">
                                {pageNo * paramsObject.limit + idx + 1}
                              </TableCell>
                              <TableCell className="text-center text-dark font-medium text-sm">
                                <span className="px-2 py-0.5 rounded bg-gray-100 text-gray-700 text-xs block mb-1">
                                  From:{" "}
                                  <Moment unix format="DD/MM/YYYY">
                                    {data.from_date}
                                  </Moment>
                                </span>
                                {data.to_date !== "0" && (
                                  <span className="px-2 py-0.5 rounded bg-gray-100 text-gray-700 text-xs block">
                                    To:{" "}
                                    <Moment unix format="DD/MM/YYYY">
                                      {data.to_date}
                                    </Moment>
                                  </span>
                                )}
                              </TableCell>
                              <TableCell className="text-dark font-medium text-sm">
                                {data.reason}
                              </TableCell>
                              <TableCell className="text-center text-dark font-medium text-sm capitalize">
                                {data.leave_type}
                              </TableCell>
                              <TableCell className="text-center">
                                {data.leave_status === "1" ? (
                                  <span className="bg-green-100 text-green-700 font-medium px-2.5 py-1 rounded-full text-xs">
                                    Approved
                                  </span>
                                ) : data.leave_status === "2" ? (
                                  <span className="bg-yellow-100 text-yellow-700 font-medium px-2.5 py-1 rounded-full text-xs">
                                    Pending
                                  </span>
                                ) : (
                                  <span className="bg-red-100 text-red-700 font-medium px-2.5 py-1 rounded-full text-xs">
                                    Rejected
                                  </span>
                                )}
                              </TableCell>
                              <TableCell className="text-center">
                                {data.file_list ? (
                                  <div className="flex items-center justify-center w-full">
                                    <Button
                                      size="sm"
                                      type="button"
                                      onClick={() =>
                                        handleFetchUserDocuments(data.id)
                                      }
                                      className="space-x-1"
                                    >
                                      <EyeIcon className="w-4 h-4" />{" "}
                                      <span>View</span>
                                    </Button>
                                  </div>
                                ) : (
                                  "---"
                                )}
                              </TableCell>
                              <TableCell className="text-center text-dark font-medium text-sm">
                                <div className="flex items-center justify-center space-x-3">
                                  {data.leave_edited && (
                                    <Link
                                      to={{
                                        pathname: `/leaves/leave-edit-history/${data.id}`,
                                      }}
                                      className="flex items-center justify-center text-gray-500 hover:text-primary transition-colors"
                                    >
                                      <EyeIcon className="w-5 h-5" />
                                    </Link>
                                  )}
                                  {role === "employee" ||
                                  role === "consultant" ? (
                                    "---"
                                  ) : (
                                    <Link
                                      to={{
                                        pathname: `/edit-leaves/${data.id}`,
                                        state: { data },
                                      }}
                                      state={data}
                                      className="flex items-center justify-center text-gray-500 hover:text-primary transition-colors"
                                    >
                                      <PencilAltIcon className="w-5 h-5" />
                                    </Link>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </RoundedContainer>
                </div>
              ))}
            {activeTab === "leaveDetails" && (
              <RoundedContainer>
                <Pagination
                  currentPage={+paramsObject.page_no}
                  lengthofItems={leaveInfo.total_count || 0}
                  limit={paramsObject.limit}
                  onPageChange={handlePageClick}
                />
              </RoundedContainer>
            )}

            {activeTab === "leavesUtilised" && (
              <div>
                <LeavesUtilised
                  currentYear={year}
                  key={year}
                  companyEmployeeId={company_employee_id}
                />
              </div>
            )}
          </div>
        )}
        <Modal
          open={isOpenDocumentModal}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[20%]">
            <div className="document-wrapper px-4 divide-y">
              <div className="document-head py-4">
                <div className="flex items-center justify-between">
                  <h3 className=" text-gray-700 text-3xl font-semibold">
                    Documents
                  </h3>
                  <div
                    className=" w-6 h-6 cursor-pointer"
                    onClick={() => setIsOpenDocumentModal(false)}
                  >
                    <XIcon className=" text-black w-full h-full" />
                  </div>
                </div>
              </div>
              <div className="document-body py-4 max-h-96 overflow-auto">
                {singleLeaveData?.file_list?.length <= 0 ? (
                  <div className="text-center my-4">
                    <p className="text-gray-700 text-2xl">
                      No Document To Show
                    </p>
                  </div>
                ) : (
                  <div className="grid grid-cols-4 gap-4">
                    {singleLeaveData?.file_list?.map((data, idx) => {
                      const { file_name, document_media_type } = data;
                      return (
                        <>
                          {document_media_type === "pdf" ? (
                            <a
                              href={file_name}
                              target="_blank"
                              rel="noopener noreferrer"
                              className=" text-center py-2 px-2 rounded bg-gray-400 text-gray-700"
                            >
                              View PDF
                            </a>
                          ) : (
                            <ZoomImage key={idx} className="h-full">
                              <img
                                src={file_name}
                                alt="dummy"
                                className="border-2 border-black w-full h-full"
                              />
                            </ZoomImage>
                          )}
                        </>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="document-foot space-x-4 py-4">
                <Button
                  variant={"outline"}
                  onClick={() => setIsOpenDocumentModal(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Modal>
        {activeTab === "newLeave" && (
          <NewLeaveDetail
            key={year}
            year={year}
            company_employee_id={company_employee_id}
          />
        )}
        {activeTab === "leavemanagement" && (
          <LeaveManagement key={year} year={year} id={company_employee_id} />
        )}
        {/* <NewLeaveDetail id={id} /> */}
      </div>
    </>
  );
}

export default LeaveDetail;
